export const SAVE_AUTH = 'SAVE_AUTH';
export const SAVE_SUPER_AUTH = 'SAVE_SUPER_AUTH';

export const saveAuth = (Auth) => {
	return { type: SAVE_AUTH, Auth: Auth }
}

export const saveSuperAuth = (Auth) => {
	return { type: SAVE_SUPER_AUTH, SuperAuth: Auth }
}